<div [tp]="notificationDropdown" [tpHideOnClick]="true" tpVariation="popper" tpPlacement="bottom-start"
  class="hover:text-gray-600 bg-gray-100 border md:border-none hover:cursor-pointer hover:bg-gray-200 text-gray-600 rounded-lg transition-colors duration-200">
  <div class="relative flex items-center gap-2 p-2">
    <avvvatars class="!flex" [value]="email()" [style]="'shape'" [border]="true" [size]="20" [radius]="6" [shadow]="true" />
    <p class="hidden md:block select-none">{{email()}}</p>
    <i class="bx bx-xs bx-chevron-down"></i>
  </div>
</div>

<ng-template #notificationDropdown let-hide let-item="data">
  <div class="max-h-[calc(100svh-250px)] overflow-y-auto overflow-x-hidden">
    <a [routerLink]="links().businessProfile!.link" (click)="hide()"
      class="flex items-center px-[20px] py-[12px] mb-1 cursor-pointer hover:bg-gray-100 hover:rounded-md active:scale-[0.95] transition-transform ease-in-out duration-100">
      <img [src]="links().businessProfile!.icon" alt="icon" class="w-[24px] h-[24px] mr-[12px]">
      <span class="text-nowrap">{{links().businessProfile!.name}}</span>
    </a>
    <a [routerLink]="links().billingAndPayment!.link" (click)="hide()"
      class="flex items-center px-[20px] py-[12px] mb-1 cursor-pointer hover:bg-gray-100 hover:rounded-md active:scale-[0.95] transition-transform ease-in-out duration-100">
      <img [src]="links().billingAndPayment!.icon" alt="icon" class="w-[24px] h-[24px] mr-[12px]">
      <span class="text-nowrap">{{links().billingAndPayment!.name}}</span>
    </a>
    <div (click)="openLogoutModal(hide)"
      class="flex items-center px-[20px] py-[12px] mb-1 cursor-pointer text-[#E31D1C] hover:bg-gray-100 hover:rounded-md active:scale-[0.95] transition-transform ease-in-out duration-100">
      <i class="bx bx-log-out text-xl mr-[12px]"></i>
      Logout
    </div>
  </div>
</ng-template>
